var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"text-muted"},[_vm._v("Copyright Neura "+_vm._s((new Date()).getFullYear()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }